import { DesktopAnimation, MobileAnimation } from './setupAnimation';

const execAnimDesktop = (
    parts: string | null,
    animation: DesktopAnimation,
): void => {
    console.log('[3d] desktop animation', parts);
    if (parts === null) {
        animation.home();
    } else if (parts === 'shaft') {
        animation.shaft();
    } else if (
        parts === 'feather'
        || parts === 'thread'
        || parts === 'kebiki'
        || parts === 'nock'
        || parts === 'twine'
        || parts === 'lame'
        || parts === 'familycrest'
        || parts === 'featherinside'
        || parts === 'decoration'
    ) {
        animation.feather();
    } else if (parts === 'arrowhead') {
        animation.yajiri();
    } else if (
        parts === 'arrowlength'
        || parts === 'unit'
        || parts === 'arrowinsert'
        || parts === 'typezero'
    ) {
        animation.yashaku();
    } else if (parts === 'carving') {
        animation.carving();
    }
};

const execAnimMobile = (
    parts: string | null,
    animation: MobileAnimation,
    mobilePreviewMode: boolean,
): void => {
    console.log('[3d] mobile animation', parts);
    if (mobilePreviewMode) {
        animation.preview1();
        return;
    }
    if (
        parts === 'shaft'
        || parts === 'feather'
        || parts === 'thread'
        || parts === 'kebiki'
        || parts === 'nock'
        || parts === 'unit'
        || parts === 'arrowinsert'
        || parts === 'arrowlength'
        || parts === 'arrowhead'
        || parts === 'twine'
        || parts === 'lame'
        || parts === 'featherinside'
        || parts === 'decoration'
        || parts === 'typezero'
    ) {
        animation.shaft();
    } else if (parts === 'carving') {
        animation.carving();
    } else if (parts === 'familycrest') {
        animation.familyCrest();
    }
};

export const execAnimation = (
    isDesktop: boolean,
    isMobile: boolean,
    parts: string | null,
    animation: { desktop: DesktopAnimation, mobile: MobileAnimation },
    mobilePreviewMode: boolean,
): void => {
    if (isDesktop === true && isMobile === false) {
        execAnimDesktop(parts, animation.desktop);
    } else if (isDesktop === false && isMobile === true) {
        execAnimMobile(parts, animation.mobile, mobilePreviewMode);
    } else if (isDesktop === false && isMobile === false) {
        execAnimDesktop(parts, animation.desktop);
    }
};
